import { useTelegram} from '../hooks/useTelegram'
import {getBaseUrl} from "./config";
import systemStore from '../storage/SystemStore'

const {tg, isValid} = useTelegram()

const getParameterByName = (name, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

const handleMessage = (msg) => {
    if(isValid()) {
        tg.showAlert(msg)
        // systemStore.setError(msg)
    } else {
        systemStore.setError(msg)
    }
    return Promise.reject(msg)
}


const AGREEMENT_REQUIRED = 'should_sign_agreement'
const AGREEMENT_REQUIRED_CODE = 522

const handleAgreementRequired = (json) => {
    const path = window.location.pathname + window.location.search

    if (window.location.pathname !== '/agreement/sign') {
        sessionStorage.setItem('agreement_return_url', path)
    }

    sessionStorage.setItem('agreement_required', '1')

    window.dispatchEvent(
        new CustomEvent('agreement-required', {
            detail: json
        })
    )

    return Promise.reject({
        type: AGREEMENT_REQUIRED,
        response: json
    })
}

export const post = async (endpoint, data) => {
    const d = new Date();
    let diff = d.getTimezoneOffset();
    const lang = sessionStorage.getItem('language') || 'ru'
    const url = `${getBaseUrl()}/${endpoint}?lang=${lang}`;
    const hasFile = Object.values(data || {}).some(v => v instanceof File || v instanceof Blob);

    
    let options = {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: { 'X-Timezone-Offset': diff }
    };
    
    if (hasFile) {
        // 🧩 Prepare multipart form
        const formData = new FormData();
        for (const [key, value] of Object.entries(data || {})) {
            if (value === undefined || value === null) continue;

            // Files / blobs: send as-is
            if (value instanceof File || value instanceof Blob) {
                formData.append(key, value);
                continue;
            }

            // Arrays / objects: JSON stringify
            if (Array.isArray(value) || (typeof value === "object")) {
                formData.append(key, JSON.stringify(value));
                continue;
            }

            // Primitives: send as string
            formData.append(key, String(value));
        }
        options.body = formData;
        // Don't set Content-Type manually — browser sets it for multipart
    } else {
        // 🧩 Regular JSON post
        options.headers['Accept'] = 'application/json';
        options.headers['Content-Type'] = 'application/json;charset=UTF-8';
        options.body = JSON.stringify(data);
    }
    const _jwt = getParameterByName('jwt') || sessionStorage.getItem('jwt')
    if(_jwt) {
        options.headers['Authorization'] = `Bearer ${_jwt}`
    }
    try {
        systemStore.setLoading(true)
        let response = await fetch(url, options)
        systemStore.setLoading(false)
        if (response.ok) {
            let json =  await response.json();
            if(json.result !== 0) {
                if (json.result === AGREEMENT_REQUIRED_CODE) {
                    return handleAgreementRequired(json)
                }
                return handleMessage(json.message)
            }
            return json;
        } else {
            return handleMessage('Байланыш катасы')
        }
    } catch(err) {
        systemStore.setLoading(false)
        return handleMessage('Байланыш катасы')
    } finally {
        systemStore.setLoading(false)
    }
}